module.exports = __webpack_public_path__ + "static/the-cheese-trap-8cb42024f7f59287254c04086684e899.jpg";